import { SalesProductDto } from '@core/services/dto';

export class SaleModel {
  applicationId: string;
  campaignId: number;
  referrers: string[];
  products: SalesProductDto [];
}
